<template>
  <Head>
    <Title>Privacy Policy</Title>
  </Head>
  <div class="privacy-policy">
    <h1 class="privacy-policy__heading">
      Privacy Policy
    </h1>

    <p class="privacy-policy__paragraph">
      BY ACCESSING OR USING æScan SERVICES, YOU AGREE TO BE BOUND BY THIS
      PRIVACY POLICY ALL TERMS INCORPORATED BY REFERENCE.
    </p>

    <p class="privacy-policy__paragraph">
      This Privacy policy applies to your access to and use of all æScan Services (our
      “Services”) provided by Aeternity Foundation, Sofia district (capital), Sofia 1164, Lozenets
      district, bul. "Hristo Smirnenski" 70, info@aeternity.com, Company-Nr.: 177240621 (“Company,” “we,” or “us”).
    </p>
    <p class="privacy-policy__paragraph">
      æScan is committed to the protection of your Personal Data and takes the matter of
      protecting your privacy as a high priority
    </p>

    <h2 class="privacy-policy__subheading">
      1. Types of data collected
    </h2>

    <p class="privacy-policy__paragraph">
      The types of Personal Data that are collected directly from you or from third parties
      include solely the data that you might provide us with by interacting with us. æScan
      collects no personal data about its users in an inherent fashion. All of the tools used
      for tracking errors and processing analytics do not collect, process, or store any
      personal data.
    </p>
    <p class="privacy-policy__paragraph">
      In the event that æScan services lead to any form of personal data being collected,
      this data shall be limited to:
    </p>
    <p class="privacy-policy__paragraph">
      (a) technical and analytical information;
    </p>
    <p class="privacy-policy__paragraph">
      (b) statistical data.
    </p>
    <p class="privacy-policy__paragraph">
      In addition, this data shall be stored and processed solely for the use of improving
      æScan services, fixing bugs, and correcting errors and will be promptly expunged
      from our systems.
    </p>
    <p class="privacy-policy__paragraph">
      This Privacy Policy covers the information collected about you when you use æScan
      products or services, or otherwise interact with æScan, unless a different privacy
      policy is displayed.
    </p>

    <p class="privacy-policy__paragraph">
      If you do not agree to the terms of this Policy, please do not use æScan, or any of its
      parts. Each time you use æScan the current version of this Privacy Policy will apply.
    </p>

    <h2 class="privacy-policy__subheading">
      2. How is your personal data collected?
    </h2>

    <p class="privacy-policy__paragraph">
      This Privacy Policy covers any Personal Data provided to æScan:
    </p>
    <p class="privacy-policy__paragraph">
      (a) when you engage with æScan;
    </p>
    <p class="privacy-policy__paragraph">
      (b) under any other contractual agreement or arrangement.
    </p>

    <p class="privacy-policy__paragraph">
      Please note that you consent to this data being collected by you using æScan
      services. If you do not agree with the terms of this Policy and this approach, please do
      not use æScan or any of its parts.
    </p>

    <h2 class="privacy-policy__subheading">
      3. How is your personal data collected?
    </h2>
    <p class="privacy-policy__paragraph">
      From æScan, your Personal Data is collected in the following ways:
    </p>
    <h3>(a) IP address</h3>

    <p class="privacy-policy__paragraph">
      Your IP address is used to help diagnose problems with æScan’s servers and to
      administer æScan.
    </p>

    <h3>(b) User feedback form</h3>
    <p class="privacy-policy__paragraph">
      The feedback form requires you to provide contact information (e.g. your name and
      email address) so that you can receive a response promptly. Your contact information
      from the registration form is used to send you important information. Your contact
      information is also used to contact you where necessary.
    </p>

    <h3> (c) General Site tracking </h3>
    <p class="privacy-policy__paragraph">
      Third-party service provider(s) are engaged as well, to assist in better understanding
      the use of æScan. These service provider(s) will place cookies on the hard drive of
      your computer and will receive information that will prove educational on such things
      as how visitors navigate around æScan, what pages are browsed, and general
      transaction information. These service provider(s) analyze this information and
      provides aggregate reports. The information and analysis provided by these service
      provider(s) will be used to assist in better understanding visitors' interests in æScan
      and how to better serve those interests. The information collected by these service
      provider(s) may be linked to and combined with information that is collected about
      you while you are using æScan. These service provider(s) are contractually restricted
      from using information they receive from æScan other than to provide assistance to
      Aeternity Foundation.
    </p>

    <h3> (d) Web Server site visits logging </h3>
    <p class="privacy-policy__paragraph">
      The following is how the web server site visit logs are stored:
    </p>

    <p class="privacy-policy__paragraph">
      (i) To throttle the rate of requests and prevent certain types of attacks, the incoming
      IP addresses are tracked for very short periods of time and are then released.
      <br>
      (ii) By default, identifiable 'x-forwarded-for' originating IPs during your site visit in the
      Web Server site visits logs are NOT stored.
      <br>
      (iii) However in the event of certain types of third-party attacks, general
      server/application troubleshooting, or other related reasons, the 'x-forwarded-for'
      logging might be temporarily activated.
      <br>
      (iv) As part of routine server maintenance, all raw web server site visit logs are
      retained for a minimum of 90 days only and then purged on an automated scheduled
      basis
    </p>

    <h2 class="privacy-policy__subheading">
      4. What is your personal data used for?
    </h2>

    <p class="privacy-policy__paragraph">
      Your Personal Data may be used for the following purposes:
    </p>

    <p class="privacy-policy__paragraph">
      (a) to enable us to provide our services and perform our services to you;
      <br>
      (b) to protect the safety and well-being of yourself and/or other customers;
      <br>
      (c) to investigate and respond to claims and inquiries from you;
    </p>
    <p class="privacy-policy__paragraph">
      (d) for business development purposes such as statistical and marketing analysis,
      systems testing, maintenance and development, and customer surveys or to help us
      in any future dealings with you, for example by identifying your requirements and
      preference;
    </p>
    <p class="privacy-policy__paragraph">
      (e) to comply with any legal or regulatory requirements; and/ or
    </p>
    <p class="privacy-policy__paragraph">
      (f) for all other purposes ancillary to any of the purposes stated above. <span
        class="privacy-policy__highlighted">(“Purposes")</span>
    </p>

    <h2 class="privacy-policy__subheading">
      5. Accessing / Correcting / Updating Your Personal Data
    </h2>
    <p class="privacy-policy__paragraph">
      You may request to obtain information on your personal data and also update or
      make amendments to your personal data.
    </p>
    <p class="privacy-policy__paragraph">
      We will endeavor to provide the information back to you as soon as practicable.
      However, we also reserve the right to validate all requests for the authenticity of the
      request.
    </p>
    <h2 class="privacy-policy__subheading">
      6. Right of Erasure
    </h2>
    <p class="privacy-policy__paragraph">
      Users have the right to have their personal data erased from æScan systems if it is no
      longer necessary in relation to the purposes for which it was collected or processed.
      At users’ request, if æScan made certain data public (with users’ consent), we will take
      reasonable steps to inform controllers that the user requested the erasure of any links
      to, or copy of, that data.
    </p>
    <h2 class="privacy-policy__subheading">
      7. Withdrawing Consent
    </h2>
    <p class="privacy-policy__paragraph">
      Please note that it is obligatory for the Aeternity Foundation to process your
      Personal Data for the Core Purpose as stated above, without which some services or
      features provided by æScan may be affected.
    </p>
    <p class="privacy-policy__paragraph">
      If you wish to withdraw your consent to process your Personal Data, please submit a
      request via email to <a href="mailto:info@aeternity.com">info@aeternity.com</a>.
    </p>
    <h2 class="privacy-policy__subheading">
      8. To whom is your personal data disclosed?
    </h2>
    <p class="privacy-policy__paragraph">
      We will not trade or sell your Personal Data to third parties. Your Personal Data shall
      only be disclosed or transferred to the following third parties appointed or authorized
      by the Company for the fulfillment of the Purpose of (a) data warehouses; (b) IT
      service providers; (c) data analytics and/or marketing agency; (d) legal bodies as
      permitted or required by law such as in compliance with a warrant or subpoena
      issued by a court of competent jurisdiction; and/or (e) regulatory authorities
      applicable to you; and/or (f) safety and security personnel.
    </p>
    <p class="privacy-policy__paragraph">
      In addition to the above, your Personal Data may also be disclosed or transferred to
      any of the Company’s actual and potential assignee, transferee, or acquirer (including
      our affiliates and subsidiaries) or our business, assets, or group companies, or in
      connection with any corporate restructuring or exercise including our restructuring to
      transfer the business, assets and/or liabilities.
    </p>
    <p class="privacy-policy__paragraph">
      We shall take practical steps to ensure that their employees, officers, agents,
      consultants, contractors, and other third parties mentioned above who are involved in
      collecting, using, and disclosing your Personal Data will observe and adhere to the
      terms of this Privacy Statement.
    </p>
    <p class="privacy-policy__paragraph">
      We are subject to various legal and regulatory obligations imposed by the laws and
      supervisory authorities of various jurisdictions, e.g., anti-money laundering laws, anti-
      terrorism financing, financial services laws, corporation laws, and privacy laws. These
      obligations may require us to process certain data for payment processing,
      compliance with court orders, or other purposes not disclosed herein.
    </p>
    <h2 class="privacy-policy__subheading">
      9. How Long Will We Retain Your Personal Data?
    </h2>
    <p class="privacy-policy__paragraph">
      The Company stores data in a global hosting provider with servers across regions, and
      we shall take all reasonable steps to ensure that all Personal Data is destroyed or
      permanently deleted when no longer required for the Purpose and prepare a disposal
      schedule for inactive data after a 24-month period.
    </p>
    <h2 class="privacy-policy__subheading">
      10. Links to Third Party Websites
    </h2>
    <p class="privacy-policy__paragraph">
      We may link this website and/or our applications to other companies or
      organizations’ websites (collectively, “Third Party Sites”). This Privacy Notice does not
      apply to such Third Party Sites as those sites are outside our control. If you access
      Third Party Sites using the links provided, the operators of these sites may collect your
      personal information.
    </p>
    <p class="privacy-policy__paragraph">
      Please ensure that you are satisfied with the privacy statements of these Third Party
      Sites before you submit any personal information.
    </p>
    <p class="privacy-policy__paragraph">
      We try, as far as we can, to ensure that all third-party linked sites have equivalent
      measures for the protection of your personal information, but we cannot be held
      responsible legally or otherwise for the activities, privacy policies, or levels of privacy
      compliance of these Third Party Sites.
    </p>
    <h2 class="privacy-policy__subheading">
      11. Additional Information and Assistance
    </h2>
    <p class="privacy-policy__paragraph">
      Please note that this Privacy Statement may be amended from time to time per
      applicable laws and regulations, and such variations may apply to you.
    </p>
    <p class="privacy-policy__paragraph">
      For further inquiries or complaints in relation to our handling of your Personal Data or
      our Privacy Policy or wish to access, update, or amend your Personal Data as
      mentioned above, please contact us via our feedback form at
      <a href="mailto:info@aeternity.com">info@aeternity.com</a>.
    </p>
  </div>
</template>

<style scoped>
.privacy-policy {
  max-width: 680px;
  margin: 0 auto;

  &__heading {
    margin-bottom: var(--space-6);
  }

  &__subheading {
    margin-bottom: var(--space-6);

    @media (--desktop ) {
      margin-bottom: var(--space-5);
    }
  }

  &__paragraph {
    margin-bottom: var(--space-5);
  }

  &__highlighted {
    font-weight: 700;
  }
}
</style>
